import "./App.css";
import UsersList from "./components/UsersList";

function App() {
  return (
    <div className="App">
      <UsersList />
    </div>
  );
}

export default App;
